export const REGEX = {
  EMAIL: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
  LATIN_ALPHABET: /[а-щА-ЩЬьЮюЯяЇїІіЄєҐґ]/,
}
